export var checkIfLinked = function (variable) {
    if (variable) {
        return variable === null || variable === void 0 ? void 0 : variable.includes(':');
    }
    else {
        return false;
    }
};
export var findThemeName = function (themeId, allThemes) {
    var themeName = '';
    allThemes.map(function (theme) {
        if (theme.id === themeId) {
            themeName = theme.name;
            return theme.name;
        }
    });
    return themeName;
};
//for color styles
export var findThemeValue = function (themeId, allThemes) {
    var themeValue;
    if (allThemes && (allThemes === null || allThemes === void 0 ? void 0 : allThemes.length)) {
        if (themeId === null || themeId === void 0 ? void 0 : themeId.includes(':')) {
            allThemes === null || allThemes === void 0 ? void 0 : allThemes.map(function (theme) {
                if ((theme === null || theme === void 0 ? void 0 : theme.id) === themeId) {
                    themeValue = theme === null || theme === void 0 ? void 0 : theme.value;
                }
            });
        }
        else {
            themeValue = themeId;
        }
    }
    return themeValue;
};
//for typography styles
export var findThemeValues = function (themeId, allThemes) {
    var themeValue;
    allThemes === null || allThemes === void 0 ? void 0 : allThemes.map(function (theme) {
        if ((theme === null || theme === void 0 ? void 0 : theme.id) === themeId) {
            themeValue = theme === null || theme === void 0 ? void 0 : theme.values;
        }
    });
    return themeValue;
};
export var isLinkedValue = function (value) {
    return typeof value === 'string' && (value === null || value === void 0 ? void 0 : value.includes(':'));
};
/**
 * Extract and return the theme value of the given variable if linked,
 * else return the unlinked value
 * @param  {string} value value of the variable
 * @param  {string} type type of the theme which needs to be evaluated (text or color)
 * @param  {[]} themes array of theme variables
 * @param  {string} field field name of the property which needs to be returned (optional: not required for colors or unlinked values)
 * @return {{} || ''} object (for typography) || string (for colors)
 */
export var retrieveThemeValue = function (value, type, themes, field) {
    var _a, _b;
    if (typeof value === 'string' && (value === null || value === void 0 ? void 0 : value.includes(':'))) {
        var usedThemeData = (themes === null || themes === void 0 ? void 0 : themes.filter(function (theme) {
            return (theme === null || theme === void 0 ? void 0 : theme.id) === value;
        })) || [];
        if (type === 'color') {
            return (_a = usedThemeData[0]) === null || _a === void 0 ? void 0 : _a.value;
        }
        else {
            var themeValues = (_b = usedThemeData[0]) === null || _b === void 0 ? void 0 : _b.values;
            if (themeValues && Object.keys(themeValues).includes(field)) {
                return themeValues[field];
            }
        }
    }
    else {
        return value;
    }
};
/**
 * Detect if the value is linked to theme or if it is a URL
 * @param  {{}} value property value of the given component
 * @return {{}} true if a theme variable, false if not
 */
export var getIfLinkOrTheme = function (value) {
    if ((value === null || value === void 0 ? void 0 : value.includes('http:')) || (value === null || value === void 0 ? void 0 : value.includes('https:'))) {
        return false;
    }
    else {
        if (value === null || value === void 0 ? void 0 : value.includes(':')) {
            return true;
        }
    }
};
/**
 * Map theme styles into a format that the canvas can render
 * if not linked to a theme value, return the same value passed in
 * @param  {{}} comp component that needs be extracted and assigned the value to
 * @param  {{}} themeData themeData object
 * @return {{}} modified comp object
 */
export var mapThemeVariableToValue = function (comp, themeData) {
    var _a;
    Object.keys((_a = comp === null || comp === void 0 ? void 0 : comp.properties) === null || _a === void 0 ? void 0 : _a.style).map(function (property) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((_b = Object.keys((_a = comp === null || comp === void 0 ? void 0 : comp.properties) === null || _a === void 0 ? void 0 : _a.style[property])) === null || _b === void 0 ? void 0 : _b.includes('value')) {
            if (((_d = (_c = comp === null || comp === void 0 ? void 0 : comp.properties) === null || _c === void 0 ? void 0 : _c.style[property]) === null || _d === void 0 ? void 0 : _d.value) !== undefined &&
                typeof ((_f = (_e = comp === null || comp === void 0 ? void 0 : comp.properties) === null || _e === void 0 ? void 0 : _e.style[property]) === null || _f === void 0 ? void 0 : _f.value) === 'string' &&
                getIfLinkOrTheme((_h = (_g = comp.properties) === null || _g === void 0 ? void 0 : _g.style[property]) === null || _h === void 0 ? void 0 : _h.value)) {
                var themeType = '';
                var themeObjType = '';
                var textThemeProperties = [
                    'fontFamily',
                    'fontSize',
                    'fontWeight',
                    'letterSpacing',
                ];
                if (textThemeProperties === null || textThemeProperties === void 0 ? void 0 : textThemeProperties.includes(property)) {
                    themeObjType = 'textStyles';
                    themeType = 'text';
                }
                else {
                    themeObjType = 'colorStyles';
                    themeType = 'color';
                }
                comp.properties.style[property].value = retrieveThemeValue((_k = (_j = comp === null || comp === void 0 ? void 0 : comp.properties) === null || _j === void 0 ? void 0 : _j.style[property]) === null || _k === void 0 ? void 0 : _k.value, themeType, themeData[themeObjType], property);
            }
        }
    });
};
